<template>
    <div>
        <v-card>
            <v-toolbar card>
                <v-toolbar-title><h4>Listado de Pólizas</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="searchFilter.name"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        @change="onSearchfilterChanged"
                        hide-details
                ></v-text-field>
            </v-toolbar>
            <v-card-text class="pa-0">
                <template>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :total-items="totalItems"
                            :pagination.sync="pagination"
                            :loading="loading"
                            :hide-actions="loading"
                            class="elevation-0"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.nro_poliza }}</td>
                            <td>{{ props.item.asesor.nombre }}</td>
                            <td>{{ props.item.aseguradora.nombre }}</td>
                            <td>
                                {{ props.item.estado }}
                                <span v-if="props.item.estado == 'cancelada'">
                                    <strong>({{ props.item.razon_cancelacion.nombre }})</strong><br/>
                                    <strong>Fecha:</strong> {{ props.item.fecha_cancelacion.format('DD-MM-YYYY') }}
                                </span>
                                <span v-else>
                                    <br/>
                                    <strong>Inicio:</strong> {{ props.item.inicio_vigencia.format('DD-MM-YYYY') }}<br/>
                                    <strong>Fin:</strong> {{ props.item.fin_vigencia.format('DD-MM-YYYY') }}
                                </span>
                            </td>
                            <td>{{ props.item.tipo_poliza.nombre }}</td>
                            <td class="text-xs-right">
                                <v-btn flat icon color="teal" @click="expandItem(props)">
                                    <v-icon>folder_open</v-icon>
                                </v-btn>
                            </td>
                        </template>
                        <template slot="expand" slot-scope="props">
                            <v-card>
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12 sm12>
                                                <v-data-table
                                                        :headers="headersInside"
                                                        :items="uploads"
                                                        :loading="loading"
                                                        :hide-actions="true"
                                                        class="elevation-0"
                                                        dense
                                                >
                                                    <template slot="items" slot-scope="props">
                                                        <td style="padding:0 5px">{{ props.item.file_name }}</td>
                                                        <td style="padding:0 5px" class="text-xs-right">
                                                            <v-btn
                                                                    color="accent"
                                                                    @click="doDownloadUpload(editedItem, props.item.id)"
                                                            >
                                                                <v-icon>attach_file</v-icon>
                                                            </v-btn>
                                                        </td>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-container>
                                        <v-layout>
                                            <v-flex sm4 xs12 >
                                                <v-btn color="secondary" @click.native="doCancel">Cerrar</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-actions>
                            </v-card>
                        </template>
                    </v-data-table>
                </template>
                <v-divider></v-divider>
            </v-card-text>
            <v-snackbar color="error" error v-if="error" :timeout="errorTimeout" :bottom="true"
                        v-model="error">
                {{ errorMessage }}
                <v-btn secondary flat @click.native="error = false">Close</v-btn>
            </v-snackbar>
        </v-card>
    </div>

</template>

<script>
  import moment from 'moment'
  import qs from 'qs'

  export default {
    data () {
      return {
        error: false,
        errorMessage: '',
        errorTimeout: 6000,
        success: false,
        successMessage: '',
        successTimeout: 2000,
        searchFilter: {
          name: '',
          aseguradora: null
        },
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          search: '',
          asesor: null,
          aseguradora: null
        },
        crudDialog: false,
        editedProps: null,
        editedItem: null,
        editedIndex: -1,
        uploads: [],
        tipos: [],
        loading: false,
        headersInside: [
          {
            text: 'Nombre Archivo',
            align: 'left',
            sortable: false,
            value: 'file_name'
          },
          { text: 'Acciones', value: 'action', align: 'right', sortable: false }
        ],
        headers: [
          {
            text: 'Número Poliza.',
            align: 'left',
            sortable: true,
            value: 'nro_poliza'
          },
          {
            text: 'Asesor',
            align: 'left',
            sortable: true,
            value: 'asesor'
          },
          {
            text: 'Aseguradora',
            align: 'left',
            sortable: true,
            value: 'aseguradora'
          },
          {
            text: 'Estado',
            align: 'left',
            sortable: true,
            value: 'estado'
          },
          {
            text: 'Tipo Póliza',
            align: 'left',
            sortable: true,
            value: 'tipo_poliza_id'
          },
          { text: 'Acciones', value: 'action', align: 'right', sortable: false }
        ]
      }
    },
    methods: {
      getDataFromApi () {
        this.loading = true
        const {sortBy, descending, page, rowsPerPage, search} = this.pagination
        this.axios.post('/cliente/polizas',
          qs.stringify(
            {
              page,
              rowsPerPage,
              sortBy,
              descending,
              search
            })).then(
          response => {
            this.items = response.data.data.map(function (item) {
              item.created = moment(item.created)
              item.updated = moment(item.updated)
              item.inicio_vigencia = moment(item.inicio_vigencia)
              item.inicio_vigencia_string = moment(item.inicio_vigencia).format('YYYY-MM-DD')
              item.fin_vigencia_string = moment(item.fin_vigencia).format('YYYY-MM-DD')
              item.fin_vigencia = moment(item.fin_vigencia)
              return item
            })
            this.totalItems = response.data.total_entries
            this.loading = false
          }
        ).catch(
          err => {
            console.log(err)
            this.loading = false
            this.errorMessage = 'Error al cargar listado'
            this.error = true
          }
        )
      },
      doDownloadUpload (item, uploadId) {
        this.axios.get('/cliente/polizas/download/' + item.id + '/' + uploadId, { responseType: 'arraybuffer' }).then(
          response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'poliza' + item.id + '_' + uploadId + '.pdf')
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al bajar el archivo'
            this.error = true
          }
        )
      },
      expandItem (props) {
        if (!props.expanded) {
          this.editedProps = props
          this.editedItem = JSON.parse(JSON.stringify(props.item))
          this.getPolizaUploads()
        }
        props.expanded = !props.expanded
      },
      getPolizaUploads () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/cliente/polizas/uploads/' + this.editedItem.id)
          .then(res => {
            this.uploads = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      },
      doCancel () {
        if (this.editedProps != null) {
          this.editedProps.expanded = false
        }
      },
      onSearchfilterChanged () {
        this.pagination.search = this.searchFilter.name
        this.pagination.page = 1
      },
      getTipos () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/tiposPoliza/search', { params: { search: '' } })
          .then(res => {
            this.tipos = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      }
    },
    watch: {
      pagination: {
        handler () {
          this.getDataFromApi()
        },
        deep: true
      }
    },
    components: {
    },
    mounted () {
      this.getTipos()
    },
    name: 'PolizaList'
  }
</script>

<style scoped>
    input[type=file] {
        position: absolute;
        left: -99999px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cliente/PolizaList.vue